var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:Object.assign({
    'pb-column': true
  },
    _vm.className,
    {flex: _vm.flex},
    ( _obj = {}, _obj[("justify-" + _vm.justify)] = true, _obj[("align-" + _vm.align)] = true, _obj ))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }